module.exports = __webpack_public_path__ + "static/media/iconTruckYellow.d231fb7b.svg";